import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { site } from "@/config/site";

/* Rend une page légale à partir d'un tableau de sections { title, content: [string | {ul:[...]}] }.
   Les segments [À COMPLÉTER] sont mis en évidence automatiquement. */
const highlight = (text) =>
  text.split(/(\[À COMPLÉTER[^\]]*\])/g).map((part, i) =>
    part.startsWith("[À COMPLÉTER") ? <mark key={i} data-testid="a-completer">{part}</mark> : <span key={i} dangerouslySetInnerHTML={{ __html: part }} />
  );

export const LegalPage = ({ title, description, path, crumb, sections, intro }) => (
  <>
    <Seo title={title} description={description} path={path} breadcrumb={crumb} />
    <PageHero crumb={crumb} eyebrow="Informations légales" title={crumb} intro={intro}>
      <p className="mt-6 text-xs uppercase tracking-[0.2em] text-white/50" data-testid="legal-updated">Dernière mise à jour : {site.legalUpdated}</p>
    </PageHero>
    {/* Modèle à faire relire par un conseil juridique avant publication. */}
    <section className="py-16 sm:py-24">
      <div className="container-x grid gap-12 lg:grid-cols-12">
        <nav aria-label="Sommaire" className="hidden lg:col-span-3 lg:block">
          <ol className="sticky top-28 space-y-2 border-l border-line text-sm">
            {sections.map((s, i) => (
              <li key={s.title}><a href={`#section-${i + 1}`} className="-ml-px block border-l-2 border-transparent py-1 pl-4 text-muted transition-colors hover:border-gold hover:text-night">{i + 1}. {s.title}</a></li>
            ))}
          </ol>
        </nav>
        <article className="prose-legal max-w-none lg:col-span-9" data-testid="legal-content">
          {sections.map((s, i) => (
            <Reveal key={s.title} as="section" id={`section-${i + 1}`} className="scroll-mt-28" y={16}>
              <h2>{i + 1}. {s.title}</h2>
              {s.content.map((c, j) =>
                typeof c === "string" ? <p key={j}>{highlight(c)}</p> : (
                  <ul key={j}>{c.ul.map((li, k) => <li key={k}>{highlight(li)}</li>)}</ul>
                )
              )}
            </Reveal>
          ))}
        </article>
      </div>
    </section>
  </>
);
